import api from '@/api/index'

const state = () => ({
  // ETF
  etfItems: [],
  list: [],
  item: {},
  code: null,
  priceList: [],
  priceItem: {},

  // ETF 테마
  etfThemeItems: [],
  items: [],
  totalCount: 0,
  theme: null,

  etfThemeItems_All:[],
  // ETF 테마 관계
  etfThemeItemsR: [],
  relationItems: [],
  relationTotalCount: 0,
  themeRelation: null,
})

const mutations = {
  // ETF
  SET_LIST(state, list) {
    const safeList = Array.isArray(list) ? list.filter(item => item && item.shortCode && item.name) : []
    safeList.forEach((row, index) => {
      row.index = index
    })
    state.list = safeList
    state.etfItems = safeList.map(({ id, shortCode, name }) => ({ id, shortCode, name }))
    console.log("state.etfItems@@@ : ", state.etfItems)
  },
  SET_DETAIL(state, item) {
    state.item = item
  },
  SET_CODE(state, shortCode) {
    state.code = shortCode
  },
  INIT_LIST(state) {
    state.list = []
  },
  INIT_DETAIL(state) {
    state.item = {}
  },
  SET_PRICE_LIST(state, list) {
    state.priceList = list
  },
  SET_PRICE_DETAIL(state, item) {
    state.priceItem = item
  },

  // 테마
  SET_ETF_THEME_LIST(state, { items, totalCount }) {
    state.items = items
    state.totalCount = totalCount
    state.etfThemeItems = items.map(({ id, name, overview }) => ({ id, name, overview }))
  },

  SET_ETF_THEME_LIST_ALL(state, { items, totalCount }) {
    state.etfThemeItems_All = items.map(({ id, name, overview }) => ({ id, name, overview }))
  },

  SET_ETF_THEME_DETAIL(state, theme) {
    state.theme = theme
  },

  // 테마 관계
  SET_ETF_THEME_RELATION(state, { items, totalCount }) {
    state.relationItems = items
    state.relationTotalCount = totalCount
    state.etfThemeItemsR = items.map(({ etfId, themeId }) => ({ etfId, themeId }))
  },
  SET_ETF_THEME_RELATION_DETAIL(state, relation) {
    state.themeRelation = relation
  },
  CLEAR_RELATIONS(state) {
    state.relationItems = []
    state.relationTotalCount = 0
  }
}

const actions = {
  // ETF
  GET_LIST({ commit }, params) {
    return api.getEtfList(params)
      .then(response => {
        const data = response.etfsList || []
        commit('SET_LIST', data)
        return data
      })
  },
  GET_DETAIL({ commit }, params) {
    return api.getEtfDetail(params)
      .then(response => {
        const item = response.etfs
        commit('SET_DETAIL', item)
        return item
      })
  },
  GET_PRICE_LIST({ commit }, params) {
    return api.getEtfPriceList(params)
      .then(response => {
        commit('SET_PRICE_LIST', response || [])
        return response || []
      })
  },
  GET_PRICE_DETAIL({ commit }, params) {
    return api.getEtfPriceDetail(params)
      .then(response => {
        const item = response.etfsPrices
        commit('SET_PRICE_DETAIL', item)
        return item
      })
  },
  GET_DISTRIBUTION_DETAIL(_, params) {
    return api.getEtDistributionsDetail(params).then(res => res.data)
  },
  GET_DISTRIBUTION_LIST(_, params) {
    return api.getEtfDistributionsList(params).then(res => res || [])
  },

  // 테마
  async GET_THEME_LIST({ commit }, params) {
    const { etfsThemesList = [], etfsThemesCnt = 0 } = await api.getEtfThemeList(params)
    const processed = etfsThemesList.map(item => ({
      ...item,
      createTime: item.createdAt?.toString().slice(0, 8),
      lastUpdateTime: item.updatedAt?.toString().slice(0, 8),
      label: convertStatus(item.status)
    }))
    commit('SET_ETF_THEME_LIST', { items: processed, totalCount: etfsThemesCnt })
    return { items: processed, totalCount: etfsThemesCnt }
  },

  async GET_THEME_LIST_ALL({ commit }, params) {
    const { etfsThemesList = [], etfsThemesCnt = 0 } = await api.getEtfThemeList(params)
    const processed = etfsThemesList.map(item => ({
      ...item,
      createTime: item.createdAt?.toString().slice(0, 8),
      lastUpdateTime: item.updatedAt?.toString().slice(0, 8),
      label: convertStatus(item.status)
    }))
    commit('SET_ETF_THEME_LIST_ALL', { items: processed, totalCount: etfsThemesCnt })
    return { items: processed, totalCount: etfsThemesCnt }
  },

  async FETCH_THEME_DETAIL({ commit }, params) {
    const { etfsThemes } = await api.getEtfThemeDetail(params)
    commit('SET_ETF_THEME_DETAIL', etfsThemes)
    return etfsThemes
  },

  // 테마 관계
  async FETCH_RELATIONS({ commit }, params) {
    const { etfsThemesRList = [], etfsThemesRCnt = 0 } = await api.getEtfThemeRelationList(params)
    commit('SET_ETF_THEME_RELATION', { items: etfsThemesRList, totalCount: etfsThemesRCnt })
    return etfsThemesRList
  },
  async FETCH_RELATION_DETAIL({ commit }, params) {
    const { etfsThemesR } = await api.getEtfThemeRelationDetail(params)
    commit('SET_ETF_THEME_RELATION_DETAIL', etfsThemesR)
    return etfsThemesR
  },
  
  CLEAR_RELATIONS_ACTION({ commit }) {
    commit('CLEAR_RELATIONS')
  }
}

const statusEnum = {
  0: '전체공개',
  1: '준비',
  2: '삭제',
  3: '내부공개'
}

const relationStatusEnum = {
  0: '공개',
  1: '준비',
  2: '편출'
}

export function convertStatus(code) {
  return statusEnum[code] || '알수없음'
}

export function convertRelationStatus(code) {
  return relationStatusEnum[code] || '기타'
}

const getters = {
  getEtfById: (state) => (id) => state.list.find(e => e.id === id),
  getEtfByShortCode: (state) => (shortCode) => state.list.find(e => e.shortCode === shortCode),
  getEtfByName: (state) => (name) => state.list.find(e => e.name === name),
  themesPageMax: state => Math.ceil(state.totalCount / 20),
  relationsPageMax: state => Math.ceil(state.relationTotalCount / 20),
}

export default {
  // namespaced: true,
  state,
  mutations,
  actions,
  getters
}
